export default (value) => value.charAt(0).toUpperCase() + value.substring(1);
